import { createSlice } from '@reduxjs/toolkit';
import { PublicationsStateProps } from '../interfaces/publications';
import { v4 as uuidv4 } from 'uuid';

const initialState: PublicationsStateProps = {
    publications: {
        fetching: "unknown",
        data: [],
        total: 0,
        found: false
    },
    searchText: "",
    versions: {
        fetching: "unknown",
        data: []
    },
    vehicleCategorySelected: ["Autos"],
    priceSelected: {
        min: "",
        max: ""
    },
    sellerSelected: [],
    fetchingAllModelsByIds: "unknown",
    dealerships: {
        fetching: "unknown",
        data: []
    },
    dealershipSelected: [],
    searchHome: [],
    agentConversation: {
        fetching: "unknown",
        data: null
    },
    sessionCaseId: uuidv4()
}

const publicationsSlice = createSlice({
    name: 'publications',
    initialState,
    reducers: {
        getPublicationsRequest: (state) => {
            state.publications.fetching = "loading";
        },
        getPublicationsSuccess: (state, action) => {
            state.publications.fetching = "success";
            state.publications.data = action.payload.publications;
            if (action.payload.page === 1 && !action.payload.suggested) {
                state.publications.total = action.payload.total;
            }
            state.publications.found = action.payload.found;
        },
        getPublicationsFailure: (state) => {
            state.publications.fetching = "failure";
        },
        setSearch: (state, action) => {
            state.searchText = action.payload;
        },
        getAllDealershipsRequest: (state) => {
            state.dealerships.fetching = "loading";
        },
        getAllDealershipsSuccess: (state, action) => {
            state.dealerships.fetching = "success";
            state.dealerships.data = action.payload;
        },
        getAllDealershipsFailure: (state) => {
            state.dealerships.fetching = "failure";
        },
        getVersionsRequest: (state) => {
            state.versions.fetching = "loading";
        },
        getVersionsSuccess: (state, action) => {
            state.versions.fetching = "success";
            state.versions.data = action.payload;
        },
        getVersionsFailure: (state, action) => {
            state.versions.fetching = "failure";
        },
        setAllDealership: (state, action) => {
            state.dealershipSelected = action.payload;
        },
        setSeller: (state, action) => {
            state.sellerSelected = action.payload;
        },
        getAllModelsByIdsRequest: (state) => {
            state.fetchingAllModelsByIds = "loading";
        },
        getAllModelsByIdsSuccess: (state, action) => {
            // state.models.data = action.payload;
            state.fetchingAllModelsByIds = "success";
        },
        getAllModelsByIdsFailure: (state) => {
            state.fetchingAllModelsByIds = "failure";
        },
        setSearchHome: (state, action) => {
            state.searchHome = action.payload;
        },
        setVehicleCategory: (state, action) => {
            state.vehicleCategorySelected = action.payload;
        },
        getAgentConversationRequest: (state) => {
            state.agentConversation.fetching = "loading";
        },
        getAgentConversationSuccess: (state, action) => {
            state.agentConversation.fetching = "success";
            state.agentConversation.data = action.payload;
        },
        getAgentConversationFailure: (state) => {
            state.agentConversation.fetching = "failure";
        },
        cleanAgentConversation: (state) => {
            state.agentConversation = initialState.agentConversation;
        },
        cleanPublicationFilters: (state) => {
            state.sellerSelected = initialState.sellerSelected;
            state.dealershipSelected = initialState.dealershipSelected;
            state.searchText = initialState.searchText;
        }
    }
});

export const {
    getPublicationsRequest,
    getPublicationsSuccess,
    getPublicationsFailure,
    setSearch,
    getVersionsRequest,
    getVersionsSuccess,
    getVersionsFailure,
    getAllDealershipsRequest,
    getAllDealershipsSuccess,
    getAllDealershipsFailure,
    setSeller,
    setAllDealership,
    getAllModelsByIdsRequest,
    getAllModelsByIdsSuccess,
    getAllModelsByIdsFailure,
    setSearchHome,
    setVehicleCategory,
    getAgentConversationRequest,
    getAgentConversationSuccess,
    getAgentConversationFailure,
    cleanAgentConversation,
    cleanPublicationFilters
} = publicationsSlice.actions;

export default publicationsSlice.reducer;